{
  "TODO": "FARE:",
  "account": "Account",
  "acreInches": "acri-pollici",
  "acres": "acri",
  "action": "Azione",
  "action_one": "Azione",
  "action_other": "Azioni",
  "actions": "Azioni",
  "active": "Attivo",
  "alert": "Attenzione",
  "appbarLinks": {
    "deviceConnections": "Connessioni",
    "devices": "Dispositivi",
    "fields": "Campi",
    "flowAnalytics": {
      "long": "Analisi del flusso",
      "short": "Analisi"
    },
    "home": "Casa",
    "schedules": "Orari",
    "settings": "Impostazioni"
  },
  "archived": "Archiviato",
  "asOfRelativeTime": "aggiornato {{val, relativetime}}",
  "back": "Indietro",
  "cancel": "Cancellare",
  "changeBtn": "Modifica",
  "changeFarmAccount": "Cambia account fattoria",
  "changesSaved": "Modifiche salvate.",
  "charging": "Ricarica",
  "checkingForUpdates": "Controllo nuovi aggiornamenti...",
  "clickToEnlarge": "Clicca per ingrandire",
  "close": "vicino",
  "codaDeviceAlias": "Alias del dispositivo",
  "code": "Codice",
  "codeSent": "Codice inviato",
  "companyName": "Sede della fattoria",
  "confirm": "Confermare",
  "confirmChanges": "Confermare le modifiche",
  "confirmationRequired": "Conferma richiesta",
  "connections": "Connessioni",
  "contactUs": "Contattaci",
  "continue": "Continuare",
  "copiedToClipboard": "Copiato negli appunti.",
  "copy": "Copia",
  "copyEmailAddress": "Copia e-mail",
  "dataNotAvailable": "Dati non disponibili",
  "datepickersMaxDateTitle": "FINE",
  "datepickersMinDateTitle": "Inizio",
  "datepickersTitle": "Intervallo di date",
  "datetimeWithVal": "{{val, datetime}}",
  "datetimeWithValAndTimezone": "{{val, datetime}} ({{timezone}})",
  "degrees": "gradi",
  "degreesWithVal": "{{val}}°",
  "delete": "Eliminare",
  "devOnly": "Solo sviluppo",
  "deviceId": "ID",
  "deviceInstallationType": "Tipo di installazione",
  "deviceInstallationTypes": {
    "center_pivot": "Perno centrale",
    "linear_move": "Spostamento lineare",
    "linear_move_controller": "Controller di spostamento lineare",
    "linear_move_monitor": "Monitor di spostamento lineare",
    "prototype": "Prototipo",
    "pump": "Pompa",
    "pump_off_only": "Pompa (solo spento)",
    "pump_on_off": "Pompa (accesa/spenta)",
    "pump_vfd": "Pompa (VFD)",
    "reel": "Bobina",
    "reel_with_booster_off_only": "Mulinello con Booster (solo spento)",
    "traveller_soft": "Viaggiatore (tubo flessibile morbido)",
    "unconfigured": "Non configurato",
    "valve": "Valvola"
  },
  "deviceLabelWithDeviceName": "Dispositivo: {{deviceName}}",
  "deviceName": "Nome dispositivo",
  "deviceNameWithDeviceInstallationType": "{{deviceName}} ({{deviceInstallationType}})",
  "deviceProfile": "Profilo del dispositivo",
  "device_one": "Dispositivo",
  "device_other": "Dispositivi",
  "devices": "Dispositivi",
  "disabled": "disabile",
  "discharging": "Scaricare",
  "dismiss": "congedare",
  "doNotShowThisAgain": "Non mostrare più questo messaggio",
  "done": "Fatto",
  "dragSlider": "Trascina il cursore",
  "dueEast": "Verso est",
  "dueNorth": "Verso nord",
  "dueSouth": "Verso sud",
  "dueWest": "Verso ovest",
  "edit": "modificare",
  "emailUs": "Inviaci un'e-mail",
  "enabled": "abilitato",
  "end": "FINE",
  "event_one": "Evento",
  "event_other": "Eventi",
  "example": "esempio",
  "exit": "Uscita",
  "experimentalFeatureTitle": "Caratteristica sperimentale",
  "experimentalFeatureWarning": "Questa funzionalità è sperimentale e potrebbe non essere completamente supportata.",
  "expiresInRelativeTime": "Scade tra {{value, relativetime}}",
  "false": "Falso",
  "farm": "azienda agricola",
  "farmLocation": "Posizione della fattoria",
  "farmScreenTitle": "Azienda agricola",
  "farmUserPermissionsTitle": "Autorizzazioni utente-azienda agricola",
  "field": "Campo",
  "fieldWithCount_one": "campo",
  "field_many": "Campi",
  "fields": "Campi",
  "fieldsWithCount_other": "campi",
  "filter": "Filtro",
  "firmwareVersion": "Versione Firmware",
  "flipSwath": "Capovolgere",
  "forbidden": "Vietato",
  "gettingDeviceActivity": "Recupero attività dispositivo...",
  "gettingFarm": "Ottenimento dati agricoli...",
  "gettingUser": "Recupero dati utente...",
  "good": "Bene",
  "goToAnalyticsSite": "Portale di analisi",
  "help": "Aiuto",
  "hint": "Suggerimento",
  "home": "Casa",
  "horizontal": "orizzontale",
  "id": "ID",
  "lastCheckInWithFallback": "Ultimo check-in: oltre 24 ore fa",
  "lastCheckInWithVal": "Ultimo check-in: {{val, relativetime}}",
  "loading": "Caricamento",
  "loadingEvents": "Caricamento eventi in corso...",
  "manage": "Maneggio",
  "menu": "Menu",
  "moderate": "Moderare",
  "more": "Di più",
  "new": "nuovo",
  "newRule": "Nuova regola",
  "newer": "più recente",
  "next": "Prossimo",
  "no": "NO",
  "noScheduledActions": "Nessuna azione pianificata",
  "none": "Nessuno",
  "notApplicable": "N / A",
  "notCharging": "Non in carica",
  "notFound": "Non trovato",
  "notNow": "Non adesso",
  "note": "Nota",
  "noteWithColon": "Nota:",
  "notificationsEnabled": "Notifiche abilitate",
  "older": "Più vecchio",
  "ongoing": "In corso",
  "oops": "Ops",
  "or": "O",
  "otpFieldLabel": "Inserisci il codice",
  "otpFieldPlaceholder": "XXXXXX",
  "pages": "Pagine",
  "percentSign": "%",
  "percentWithVal": "{{val}}%",
  "poor": "Povero",
  "preparingDemo": "Preparazione dell'ambiente demo...",
  "previous": "Precedente",
  "readonly": "di sola lettura",
  "reelRun": "Corsa della bobina",
  "reelRun_one": "Corsa della bobina",
  "reelRun_other": "Rullo corre",
  "relativeTimeWithVal": "{{val, relativetime}}",
  "reportAProblem": "Segnala un problema",
  "requestSentToDevice": "Richiesta inviata al dispositivo...",
  "resendCode": "Reinvia codice",
  "result": "Risultato",
  "reviewAndSubmit": "Rivedi e invia",
  "save": "salva",
  "select": "Selezionare",
  "selected": "selezionato",
  "self": "Se stesso",
  "sensorNameWithLabel": "{{sensorName}} Sensore",
  "sensorWithSensorName": "{{sensorName}} Sensore",
  "sensor_many": "sensori",
  "sensor_one": "sensore",
  "settings": "Impostazioni",
  "showLess": "Mostra meno",
  "showMore": "Mostra altro",
  "signOut": "Disconnessione",
  "skipForNow": "Salta per ora",
  "offlineErrorMessage": "Sei offline. Controlla la connessione e riprova.",
  "offlineIndicator": "Offline",
  "permissionDeniedErrorMessage": "Non hai i permessi per farlo.",
  "somethingWentWrong": "Qualcosa è andato storto.",
  "sort": "ordinare",
  "sourceDevice": "Dispositivo sorgente",
  "start": "Inizio",
  "startOver": "Ricominciare",
  "submit": "Invia",
  "success": "Successo",
  "support": "Supporto",
  "targetDevice": "Dispositivo di destinazione",
  "time": "Tempo",
  "true": "VERO",
  "undo": "disfare",
  "unknown": "Sconosciuto",
  "valWithColon": "{{val}}:",
  "verifiedFalse": "Non verificato",
  "verifiedTrue": "Verificato",
  "warning": "Avvertimento",
  "welcome": "Benvenuto",
  "whyDoWeCollectThis": "Perché raccogliamo queste informazioni?",
  "yes": "SÌ"
}
